import {
    userInfo
} from "os";
import http from "@/lib/http";
export const pCommonMixins = {
    data() {
        return {
            s1Data: [
                { title: "co_code", name: this.getLabel('code'), isNumeric: 0 },
                { title: "name", name: this.getLabel('Company'), isNumeric: 0, isLink: 1 },
                { title: "sector_name", name: this.getLabel('sector'), isNumeric: 0 },
                { title: "market_capitalization", name: this.getLabel('market_cap'), isNumeric: 1 },
                { title: "p11_actual", name: this.getLabel('P11'), isNumeric: 1, hasColor: 1, color: "p11_color" },
                { title: "q1_a_b_greater", name: this.getLabel('Greater Q1A / Q1B'), isNumeric: 1, hasColor: 1 },
                { title: "p11_quarterly_trends", name: this.getLabel('Quarterly Trend'), isNumeric: 1, hasColor: 1 },
                { title: "q1_a", name: this.getLabel('Q1 A'), isNumeric: 1 },
                { title: "q1_b", name: this.getLabel('Q1 B'), isNumeric: 1 },
                { title: "q1_c", name: this.getLabel('Q1 C'), isNumeric: 1 },
                { title: "q1_d", name: this.getLabel('Q1 D'), isNumeric: 1 },
                { title: "valuation_trends_ebit_per_ev", name: this.getLabel('Ebit/EV'), isNumeric: 0 },
                { title: "valuation_trends_ev_per_ebitda", name: this.getLabel('EV/EbitDA'), isNumeric: 0 },
                { title: "valuation_trends_p_per_s", name: this.getLabel('P/S'), isNumeric: 0 },
                { title: "valuation_trends_pb_ratio", name: this.getLabel('PB Ratio'), isNumeric: 0 },
                { title: "valuation_trends_pcf_ratio", name: this.getLabel('PCF Ratio'), isNumeric: 0 },
                { title: "valuation_trends_pe_ratio", name: this.getLabel('PE Ratio'), isNumeric: 0 },

                { title: "latest_free_cash_flow", name: this.getLabel('FCF'), isNumeric: 1, hasColor: 1, color: 'latest_free_cash_flow_color' },
                { title: "last_year_free_cash_flow", name: this.getLabel('FCF LY'), isNumeric: 1, hasColor: 1, color: 'latest_free_cash_flow_color' },
                { title: "insider_acquisition", name: this.getLabel('insider_acquisition'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "insider_disposal", name: this.getLabel('insider_disposal'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "latest_promoter_holding", name: this.getLabel('promoter_holding'), isNumeric: 1, hasColor: 1, color: 'latest_promoter_holding_color' },
                { title: "Promoter_PledgeSharesPercentage", name: this.getLabel('Pledged Shares (%)'), isNumeric: 1 },
                { title: "govtflag", name: this.getLabel('Public Sector'), isNumeric: 0 },
                { title: "holding_company", name: this.getLabel('Holding Company'), isNumeric: 0 },

                { title: "latest_competative_advantage", name: this.getLabel('competative_advantage'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "latest_consistency_analysis", name: this.getLabel('consistency_analysis'), isNumeric: 0, hasColor: 1, color: 'latest_consistency_analysis_color' },
                { title: "latest_cyclical", name: this.getLabel('latest_cyclical'), isNumeric: 0, hasColor: 0, color: '' },
                { title: "latest_trends_more_than_or_equal_five_yes", name: this.getLabel('turnaround_possiblity'), isNumeric: 0, hasColor: 1, color: 'latest_trends_more_than_or_equal_five_yes_color' },
                { title: "actual_market_share", name: this.getLabel('market_share'), isNumeric: 1, hasColor: 1, color: 'actual_market_share_color' },
                { title: "last_year_market_share", name: this.getLabel('LY market_share'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "assets_heavy_or_light", name: this.getLabel('assets_heavy/light'), isNumeric: 0, hasColor: 0, color: '' },
                { title: "capex_management", name: this.getLabel('capex_management'), isNumeric: 0, hasColor: 0, color: '' },

                { title: "actual_latest_roe", name: this.getLabel('ROE'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "p2_retained_earning", name: this.getLabel('Retained_Earnings'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "actual_latest_total_debt_per_net_worth", name: this.getLabel('D/E'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "actual_latest_sales_per_invested_capital", name: this.getLabel('Asset_turnover'), isNumeric: 1, hasColor: 0, color: '' },
                { title: "actual_latest_debtors_per_creditors", name: this.getLabel('debtors/Creditors'), isNumeric: 1, hasColor: 0, color: '' },

                { title: "valuation_trends_sales_per_invested_capital", name: this.getLabel('Sales/Invested Capital'), isNumeric: 0 },
                { title: "valuation_trends_ns_per_inventory", name: this.getLabel('NS/Inventory'), isNumeric: 0 },
                { title: "valuation_trends_ns_per_debtors", name: this.getLabel('NS/Debtors'), isNumeric: 0 },
                { title: "valuation_trends_total_expenditure_per_creditors", name: this.getLabel('Total Exp/Creditors'), isNumeric: 0 },

                { title: "actual_sales_growth_cagr_10_years", name: this.getLabel('Sales Growth CAGR 10Yrs'), isNumeric: 1, hasColor: 1, color: 'sales_growth_cagr_10_years_color' },
                { title: "actual_sales_growth_cagr_5_years", name: this.getLabel('Sales Growth CAGR 5Yrs'), isNumeric: 1, hasColor: 1, color: 'sales_growth_cagr_5_years_color' },
                { title: "actual_eps_growth_cagr_10_years", name: this.getLabel('EPS Growth CAGR 10Yrs'), isNumeric: 1, hasColor: 1, color: 'eps_growth_cagr_10_years_color' },
                { title: "actual_eps_growth_cagr_5_years", name: this.getLabel('EPS Growth CAGR 5Yrs'), isNumeric: 1, hasColor: 1, color: 'eps_growth_cagr_5_years_color' },
                { title: "sector_sales_cagr_10_years", name: this.getLabel('Sector Sales CAGR 10Yrs'), isNumeric: 1, hasColor: 1, color: 'eps_growth_cagr_5_years_color' },
                { title: "sector_sales_cagr_5_years", name: this.getLabel('Sector Sales CAGR 5Yrs'), isNumeric: 1, hasColor: 1, color: 'eps_growth_cagr_5_years_color' },

                { title: "actual_latest_ebitDA_per_sales", name: this.getLabel('EBITDA/Sales'), isNumeric: 1, hasColor: 1, color: 'latest_ebitDA_per_sales_color' },
                { title: "valuation_trends_ebitDA_per_sales", name: this.getLabel('EbitDA/Sales Trends'), isNumeric: 0 },

                { title: "actual_latest_lna_per_net_worth", name: this.getLabel('LNA/NW'), isNumeric: 1, hasColor: 1, color: "latest_lna_per_net_worth_color" },
                { title: "valuation_trends_lna_per_net_worth", name: this.getLabel('LNA/NW Trends'), isNumeric: 0 },
                { title: "actual_latest_cfo_per_ebitda", name: this.getLabel('CFO/EbitDA'), isNumeric: 1, hasColor: 1, color: "latest_cfo_per_ebitda_color" },
                { title: "valuation_trends_cfo_per_ebitDA", name: this.getLabel('CFO/EbitDA Trends'), isNumeric: 0 },
                { title: "actual_latest_tax_per_pbt", name: this.getLabel('Tax/PBT'), isNumeric: 1, hasColor: 1, color: "latest_tax_per_pbt_color" },
                { title: "latest_total_taxes_accounted", name: this.getLabel('Total Taxes Accounted'), isNumeric: 1 },
                { title: "latest_total_taxes_paid", name: this.getLabel('Total Taxes paid'), isNumeric: 1, hasColor: 1, color: "latest_total_taxes_paid_color" },

                { title: "L_qtr_YOY_net_sales", name: this.getLabel('L_qtr_YOY_net_sales'), isNumeric: 0, hasColor: 0, color: '' },
                { title: "L-1_qtr_YOY_net_sales", name: this.getLabel('L-1_qtr_YOY_net_sales'), isNumeric: 0, hasColor: 0, color: '' },
                { title: "L_qtr_YOY_eps", name: this.getLabel('L_qtr_YOY_eps'), isNumeric: 0, hasColor: 0, color: '' },
                { title: "L-1_qtr_YOY_eps", name: this.getLabel('L-1_qtr_YOY_eps'), isNumeric: 0, hasColor: 0, color: '' },
            ]
        }
    },
    methods: {

        //Pdata
        getPData() {
            let myself = this;
            // console.log("RawData Len", myself.rawData);
            if (myself.rawData.length === 0) {
                myself.isTabChanged = true;
            }
            myself.rawData = {};
            let data = {};
            if (myself.rawDataApi === 'getPSumData') {
                data = {
                    my_date: (myself.ddate != '') ? myself.getDate(myself.ddate) : '',
                    m_filter: myself.selFilter,
                    min_range: myself.minRange,
                    max_range: myself.maxRange,
                    sector: myself.sectorname,
                    p_name: myself.tabs[myself.actTab].title
                };
                // console.log("POST DATA", data);
                http.post(
                    myself.rawDataApi, data,
                    (error, response) => {
                        if (response.length > 0) {
                            myself.rawData = response; //.slice(0, 500);
                            myself.searchData = response; //.slice(0, 500);
                            // console.log(new Date(myself.rawData[0].date));
                            myself.ddate = (myself.rawData[0]) ? new Date(myself.rawData[0].date) : myself.ddate;
                            // console.log(myself.isTabChanged, myself.searchData);
                            // if (myself.isTabChanged) {
                            myself.getTableFields();
                            //     myself.isTabChanged = true;
                            // }
                        }
                    }
                );
            } else {
                data = {
                    my_date: myself.getDate(myself.ddate),
                    m_filter: myself.selFilter,
                    min_range: myself.minRange,
                    max_range: myself.maxRange,
                    sector: myself.sectorname
                };
            }

        },
        filtData(obj) {
            // console.log("Filter", obj.min, obj.max, obj.selField);
            this.ddate = new Date(obj.durDate);
            this.minRange = obj.min; //JSON.stringify(obj.min);
            this.maxRange = obj.max; //JSON.stringify(obj.max);
            this.selFilter = obj.selField; //JSON.stringify({mfilter1: obj.selField[0], mfilter2: obj.selField[1]}); //JSON.stringify(obj.selField);
            this.sectorname = obj.sector;
            this.isTabChanged = false;
            this.getPData();
        },
        filterRangeData(event) {
            this.clearData();
            var ind = event.target.value;
            this.selRangeFilter = this.mcOptions[ind].id;
            if (this.selRangeFilter === 0) {
                this.rawData = this.searchData;
                return this.rawData;
            } else {
                var minRange = this.mcOptions[ind].min;
                var maxRange = this.mcOptions[ind].max;
                this.rawData = this.searchData.filter(rd => {
                    // console.log(
                    //     rd.market_capitalization,
                    //     this.selRangeFilter,
                    //     minRange,
                    //     maxRange
                    // );
                    if (minRange != "" && maxRange != "") {
                        return (
                            parseInt(rd["market_capitalization"]) >= parseInt(minRange) &&
                            parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
                        );
                    } else {
                        if (minRange != "") {
                            return (
                                parseInt(rd["market_capitalization"]) >= parseInt(minRange)
                            );
                        }
                        if (maxRange != "") {
                            return (
                                parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
                            );
                        }
                    }
                });
            }
            setTimeout(() => {
                this.sortColumn(this.tableFields[2], 2);
            });
        },
        filteredList(e) {
            this.selRangeFilter = 0;
            this.selFilter = "";
            if (this.searchText === null || this.searchText === "") {
                this.rawData = this.searchData;
                return this.rawData;
            } else if (this.searchText.length <= 2) {
                this.rawData = this.searchData;
                return this.rawData;
            }
            if (this.searchText.length > 2 || e.keyCode === 13) {
                this.rawData = this.searchData.filter(rd => {
                    return (
                        rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
                        (rd.name ?
                            rd.name.toLowerCase().includes(this.searchText.toLowerCase()) :
                            false)
                    );
                });
            }
        },
        clearData() {
            this.selRangeFilter = 0;
            this.selFilter = "";
            this.sectorname = "";
            this.searchText = "";
            this.rawData = this.searchData;
        },
        getTableFields() {
            console.log('actTab', this.actTab);
            if (this.rawData.length > 0) {
                this.filterOptions = [{
                    id: "",
                    value: "Select",
                    isNumeric: true,
                    sort_order: 0
                }];
                var tblFields = Object.keys(this.rawData[0]);
                this.tableFields = [];
                tblFields.forEach((val, key) => {
                    if (val !== "date" && val !== '_id') {
                        if (val === "data") {
                            var raCols = Object.keys(this.rawData[0][val]);
                            raCols.forEach((value, k) => {
                                // if(this.tableFields.length<50){
                                this.tableFields.push({
                                    title: value,
                                    name: (this.getCustomLabel(value)) ? this.getCustomLabel(value) : this.getLabel(value),
                                    isNumeric: (typeof this.rawData[0][value] === "string") ? false : true,
                                    sort: 6,
                                    sort_order: 6,
                                    isLink: 0,
                                    isSortable: 1
                                });
                                // }  
                            });
                        } else {
                            if (val !== 's1_data' && this.tabs[this.actTab].title !== 's1') {
                                this.tableFields.push({
                                    title: val,
                                    name: (this.getCustomLabel(val)) ? this.getCustomLabel(val) : this.getLabel(val),
                                    isNumeric: (val === "co_code" || val === "name" || val === "sector_name") ? false : true,
                                    sort: val === "co_code" ?
                                        1 : val === "name" ?
                                            2 : val === "market_capitalization" ?
                                                4 : val === "sector_name" ?
                                                    3 : 5,
                                    sort_order: val === "co_code" ?
                                        1 : val === "name" ?
                                            2 : val === "market_capitalization" ?
                                                4 : val === "sector_name" ?
                                                    3 : 5,
                                    isLink: val === "name" ? 1 : 0,
                                    isSortable: 1
                                });
                            }
                        }
                    }
                    if (
                        val !== "co_code" &&
                        val !== "_id" &&
                        val !== "date" &&
                        val !== "name" &&
                        val !== "sector_name" &&
                        val !== "s1_data" && this.tabs[this.actTab].title !== 's1'
                    ) {
                        if (val === "data") {
                            var raCols = Object.keys(this.rawData[0][val]);
                            raCols.forEach((valuee, k) => {
                                this.filterOptions.push({
                                    id: valuee,
                                    value: (this.getCustomLabel(valuee)) ? this.getCustomLabel(valuee) : this.getLabel(valuee),
                                    isNumeric: true,
                                    sort_order: valuee === "market_capitalization" ? 1 : 2
                                });
                            });
                        } else {
                            this.filterOptions.push({
                                id: val,
                                value: (this.getCustomLabel(val)) ? this.getCustomLabel(val) : this.getLabel(val),
                                isNumeric: true,
                                sort_order: val === "market_capitalization" ? 1 : 2
                            });
                        }
                    }
                });
                this.tableFields = this.sorted_fields_asc(
                    this.tableFields,
                    "sort"
                );
                if (this.tabs[this.actTab].title === 's1') {
                    //     this.tableFields.push(this.s1Data[0]);
                    this.tableFields = this.s1Data;
                }
                // console.log("Table fields", this.tabs[this.actTab].title, this.tableFields, this.filterOptions);
            }
        }
    },
    mounted() { }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/pcommon.js